import { FeatureSwitchGate } from '../../../shared/components/gates/FeatureSwitchGate';
import { Features } from '@billda/features-ui';
import { PermissionGate } from '../../../shared/components/gates/PermissionGate';
import { Permissions } from '@billda/permissions-ui';
import { PageHeader } from '@billda/design-system';
import { BilldaLogo } from '../../../shared/components/atoms/BilldaLogo';
import { DashboardSiteBurndown } from '../components/DashboardSiteBurndown';
import { MetricsGrid } from '../components/organisms/MetricsGrid';
import { OpenPotsWidget } from '../components/OpenPotsWidget';
import { PotStatusOverview } from '../components/PotStatusOverview';
import { UnapprovedAllocationsWidget } from '../components/UnapprovedAllocationsWidget';
import { WeeklyAllocationTrend } from '../components/WeeklyAllocationTrend';
import { PeriodBadge } from '../components/PeriodBadge';
import { useGreeting } from '../hooks/useGreeting';
import { useGetDashboardPeriodInfo } from '../hooks/useGetDashboardPeriodInfo';
import { formatDateRange, formatWeekLabel } from '../utils/periodFormatting';

export default function DashboardPage() {
  const greeting = useGreeting();
  const { data: periodInfo, isLoading } = useGetDashboardPeriodInfo();
  const periods = periodInfo?.periods ?? [];

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="min-h-0 flex-1 overflow-auto p-6">
        <div className="mx-auto flex max-w-[1280px] flex-col gap-6">
          <PageHeader
            title="Dashboard"
            subtitle={greeting}
            leading={
              <div className="flex size-12 items-center justify-center rounded-xl bg-surface-primary-soft">
                <BilldaLogo variant="icon" width={40} />
              </div>
            }
            actions={
              <PeriodBadge
                weekLabel={formatWeekLabel(periods)}
                dateRange={formatDateRange(periods)}
                isLoading={isLoading}
              />
            }
            className="border-b-0 bg-transparent px-0 py-0"
          />
          <MetricsGrid />
          <div className="flex flex-col gap-6 md:flex-row md:items-stretch">
            <PotStatusOverview />
            <WeeklyAllocationTrend />
          </div>
          <div className="flex flex-col gap-6 md:flex-row md:items-stretch">
            <FeatureSwitchGate
              feature={Features.Dashboard.IsUnapprovedAllocationsEnabled}
            >
              <PermissionGate permission={Permissions.Labour.Approve}>
                <UnapprovedAllocationsWidget />
              </PermissionGate>
            </FeatureSwitchGate>
            <FeatureSwitchGate feature={Features.Dashboard.IsOpenPotsEnabled}>
              <PermissionGate permission={Permissions.Pots.All.Read}>
                <OpenPotsWidget />
              </PermissionGate>
            </FeatureSwitchGate>
          </div>
          <FeatureSwitchGate
            feature={Features.Dashboard.IsSiteBurndownChartEnabled}
          >
            <PermissionGate permission={Permissions.Sites.Financial.Read}>
              <DashboardSiteBurndown />
            </PermissionGate>
          </FeatureSwitchGate>
        </div>
      </div>
    </div>
  );
}
